import React, { useState } from "react";
import { Box, Text } from "@chakra-ui/react";
import PaymentMethodSelector from "components/PaymentMethodSelector";
import StatementDescriptor from "components/StatementDescriptor";
import { FormattedMessage } from "react-intl";
import { useSessionCtx, parsePMIDFromFlowState } from "utils";

/**
 * SelectPaymentMethod
 * @description
 * Used for Payment Selection flow.
 * This component renders the entire list of payment methods
 * and lets user pick just enough payment methods to complete their
 * transaction.
 * @param {object} props
 * @param {object} props.chooserConfig - "filter" used to get the correct payment methods.
 * @param {object} props.transactionDetails - The amount and currency that the user is trying to transact.
 */
const SelectPaymentMethods = ({
  chooserConfig,
  onSubmit,
  transactionDetails = { transaction_amount: 0, currency: "USD" },
  enableAutoRedirect,
  onAddPMOpen,
  onAddPMClose,
}) => {
  // sometimes the amount is in string, we will parse to always work with int
  const transactionAmount = parseInt(transactionDetails.transaction_amount) || undefined; // parseInt could return NaN which can cause problems so let's catch with undefined

  const { sessionCtx } = useSessionCtx();
  const preferredPaymentMethodId = parsePMIDFromFlowState(sessionCtx.flowState);

  const statementDescriptor = chooserConfig.statementDescriptor;

  const [isLoading, setIsLoading] = useState(true);

  const handleLoading = (isLoading) => {
    setIsLoading(isLoading);
  };

  return (
    <Box mt="3">
      {!isLoading && (
        <Text fontSize="sm">
          <FormattedMessage
            defaultMessage="Please select your preferred payment method or add a new one by clicking the link below"
            description="sub header"
          />
        </Text>
      )}

      <PaymentMethodSelector
        params={[{ capability: "purchase" }]}
        amount={transactionAmount}
        chooserConfig={chooserConfig}
        onSubmit={onSubmit}
        enableAutoRedirect={enableAutoRedirect}
        onAddPMOpen={onAddPMOpen}
        onAddPMClose={onAddPMClose}
        onLoading={handleLoading}
        preferredPaymentMethodId={preferredPaymentMethodId}
      />

      {!isLoading && statementDescriptor && (
        <StatementDescriptor mt="100px" descriptor={statementDescriptor} />
      )}
    </Box>
  );
};

export default SelectPaymentMethods;
